import {
  forwardRef,
  type ReactNode,
  type ComponentPropsWithoutRef,
} from 'react';

import { cn } from '@/lib/utils/tailwind';

type CardRootProps = ComponentPropsWithoutRef<'div'> & {
  children: ReactNode;
  className?: string;
};

const Root = forwardRef<HTMLDivElement, CardRootProps>(
  ({ className, children, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'group relative block p-1',
        'hover:scale-[1.02] active:scale-95 transition-transform duration-150',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  ),
);
Root.displayName = 'CardRoot';

export { Root };
